export const PROXY_PREFIX = 'http://local.omni.cws.xfinity.com:3003/';

// export const BASE_URL = `${PROXY_PREFIX}http://ebzweb-dt-1d12:85`;
//export const BASE_URL = '';

export const BASE_URL = process.env.NODE_ENV === 'production' ? ``
  : (process.env.MOCK)? `${PROXY_PREFIX}http://localhost:3005` : `${PROXY_PREFIX}http://www.dev12.xfinity.com`;

//  : (process.env.MOCK)? `${PROXY_PREFIX}http://localhost:3005` : `${PROXY_PREFIX}http://myplan.xfinity.com:8080`;
//export const BASE_URL = process.env.NODE_ENV === 'production' ? `` : `${PROXY_PREFIX}http://localhost:3005`;



/** WEBPACK FOOTER **
 ** ./client/util/constants/endpoints.js
 **/